export default __webpack_public_path__ + "static/media/file-check.a4f26574.svg";